UI.showLoader()
const objContext = JSON.parse(sessionStorage.getItem("context"));
if(objContext == null || objContext.store_name == null)
    location.href='index.html';

var map = null, geocodeService = null, marker = null;

document.getElementById("profile-form-logo").src = objContext.store_image
document.querySelector('.sidebar-profile-img img').src = objContext.store_image
document.querySelector('.sidebar-profile-name-store').innerHTML = objContext.store_name.replace(/\\/, '')

document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';

fetch(BASE_URLS.Dinny.api + '/states?req_id=' + new Date().getTime(),
{
    credentials: 'include'
})
.then(function(cityResponse){
    if(cityResponse.ok){
        cityResponse.json().then(function(json){
            for(var c=0; c < json.length; c++){
                document.getElementById('estado').insertAdjacentHTML(
                    'beforeend',
                    "<option value='" + json[c].id + "'>" + json[c].name + "</option>"
                );
            }

            fetch(
              BASE_URLS.Dinny.api + '/category/list/0?req_id=' + new Date().getTime(),
                {
                  method: 'GET',
                  credentials: 'include'
                }
            ).then(function(catResponse){
              if(catResponse.ok){
                catResponse.json().then(function(arrCategories){
                  for(let idxCat = 0; idxCat < arrCategories.length; idxCat++){
                    if(arrCategories[idxCat].id == -1)
                      continue;
                    document.getElementById('store_category').insertAdjacentHTML(
                      'beforeend',
                      "<option value='" + arrCategories[idxCat].name + "'>" + arrCategories[idxCat].name + "</option>"
                  );
                  }


                  fetch(
                    BASE_URLS.Dinny.api + '/stores/' + localStorage.getItem('currentStore') +'?req_id=' + new Date().getTime(),
                    {
                        credentials: 'include'
                    }
                  ).then(function(response){
                    if(response.ok){
                      response.json().then(function(json){

                        document.getElementById("store-name").value = json.store.name
                        document.getElementById("store_prefix").value = json.store.prefix
                        var selected = (json.store.address.cityId && json.store.address.cityId != '') ? json.store.address.cityId : 0
                        document.getElementById('estado').value = selected
                        document.getElementById("store-city").value = json.store.address.city
                        document.getElementById("store-street").value = json.store.address.street
                        document.getElementById("store-neighborhood").value = json.store.address.neighborhood
                        document.getElementById("store-num").value = json.store.address.number
                        document.getElementById("store-int").value = json.store.address.int
                        document.getElementById("store-zip_code").value = json.store.address.zip_code
                        document.getElementById("store-contact").value = json.store.contact
                        document.getElementById("store-id").value = json.store_id
                        document.getElementById("profile-form-logo").src = `${json.store.logo}?v=${new Date().getTime()}`

                        if(json.category){
                          document.getElementById('store_category').value = json.category;
                        }

                        let setMarker = false;
                        if(json.store.address.location){
                          if(json.store.address.location.lat && json.store.address.location.lon){
                            document.getElementById('hdn-lat').value = json.store.address.location.lat;
                            document.getElementById('hdn-lon').value = json.store.address.location.lon;
                            setMarker=true;
                          }
                        }

                        //document.querySelector('.sidebar-profile-location').innerHTML = json.store.address.city

                        var schedules = json.menu[0].schedules
                        for(var s in schedules){
                            //document.getElementById(schedules[s].day_of_week.replace('Domingo', 'sunday').replace('Lunes', 'monday').replace('Martes', 'tuesday').replace('Miercoles', 'wednesday').replace('Miércoles', 'wednesday').replace('Jueves', 'thursday').replace('Viernes', 'friday').replace('Sabado', 'saturday').replace('Sábado', 'saturday')).checked = true;
                            //document.getElementById("store-schedule-start").value = schedules[s].periods[0].start
                            //document.getElementById("store-schedule-end").value = schedules[s].periods[0].end
                        }

                        //Initialize map
                        map = L.map('mapid').setView([document.getElementById('hdn-lat').value, document.getElementById('hdn-lon').value], setMarker ? 17 : 13);

                        if(setMarker){
                          marker = new L.marker([document.getElementById('hdn-lat').value, document.getElementById('hdn-lon').value]);
                          map.addLayer(marker);
                        }
                        else{
                          map.locate({ setView: true });
                        }

                        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                          attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
                        }).addTo(map);

                        L.Control.geocoder({
                          defaultMarkGeocode: false
                        }).on('markgeocode', function(e) {
                          map.setView(e.geocode.center);
                        }).addTo(map);

                        geocodeService = L.esri.Geocoding.geocodeService();
                        map.on('click', function(e){
                          if(marker != null)
                            map.removeLayer(marker)
                          marker = new L.marker([e.latlng.lat, e.latlng.lng]);
                          map.addLayer(marker);
                          map.setView([e.latlng.lat, e.latlng.lng]);

                          geocodeService.reverse().latlng([e.latlng.lat, e.latlng.lng]).run(function (error, result) {
                            console.log(result);

                            let addNum = result.address.AddNum || "";
                            let calle = result.address.Address.replace('Calle', '').replace(addNum, "").trim();
                            document.getElementById("store-city").value = result.address.City;
                            document.getElementById("store-street").value = calle;
                            document.getElementById("store-neighborhood").value = result.address.Neighborhood;
                            document.getElementById("store-num").value = !isNaN(addNum) ? (addNum.length > 0 ? parseInt(addNum) : "") : "";
                            document.getElementById("store-int").value = "";
                            document.getElementById("store-zip_code").value = result.address.Postal;
                            document.getElementById("hdn-lat").value = e.latlng.lat;
                            document.getElementById("hdn-lon").value = e.latlng.lng;

                            let sel_opts = document.getElementById('estado').options, state_name = result.address.Region;
                            if(state_name == "México")
                              state_name = "Estado de México";
                            for(let idx = 0; idx < sel_opts.length; idx++){
                              if(sel_opts[idx].text.toLowerCase().indexOf(state_name.toLowerCase()) != -1){
                                document.getElementById('estado').value = sel_opts[idx].value
                                break;
                              }
                            }
                          });
                        })
                      })
                      UI.hideLoader()
                    }else{
                      response.json().then(function(content){
                        return UI.message({title:'Datos generales y contacto', content: "Ocurrió un error al cargar el establecimiento.", accept: 'Aceptar'})
                      })
                    }
                  })
                  .catch(function(e){
                    return UI.message({title:'Datos generales y contacto', content: "Ocurrió un error al cargar el establecimiento.", accept: 'Aceptar'})
                  })
                });
              }else{
                return UI.message({title:'Datos generales y contacto', content: "Ocurrió un error al cargar el establecimiento.", accept: 'Aceptar'})
              }
            }).catch(function(e){
              return UI.message({title:'Datos generales y contacto', content: "Ocurrió un error al cargar el establecimiento.", accept: 'Aceptar'})
            });
        })
        .catch(function(e){
          return UI.message({title:'Datos generales y contacto', content: "Ocurrió un error al cargar el establecimiento.", accept: 'Aceptar'})
        })
    }else{
        if(403 == cityResponse.status){
            window.location.href = 'login.html'
        }else{
          return UI.message({title:'Datos generales y contacto', content: "Ocurrió un error al cargar las ciudades.", accept: 'Aceptar'})
        }
    }
})
.catch(function(e){
    console.log('get state exception', e)
    return UI.message({title:'Datos generales y contacto', content: "Ocurrió un error al cargar las ciudades.", accept: 'Aceptar'})
})

function saveAction(e){
  e.preventDefault()
  UI.showLoader()

  let body = {
      id: localStorage.getItem('currentStore'),
      storeId: localStorage.getItem('currentStore'),
      name: document.getElementById("store-name").value,
      prefix: document.getElementById("store_prefix").value,
      category: document.getElementById('store_category').value,
      address: {
          city: document.getElementById("store-city").value,
          cityId: document.getElementById("estado").value,
          int: document.getElementById("store-int").value,
          neighborhood: document.getElementById("store-neighborhood").value,
          number: document.getElementById("store-num").value,
          street: document.getElementById("store-street").value,
          zip_code: document.getElementById("store-zip_code").value,
          location: {
            lat: document.getElementById('hdn-lat').value,
            lon: document.getElementById('hdn-lon').value
          }
      },
      contact: document.getElementById("store-contact").value,
      delivery:[],
      payments:[]
  }
  if(document.getElementById("store-logo").files.length > 0){
    const reader = new FileReader()
    reader.onerror = function(){
      UI.message({
        title: 'Datos generales y de contacto',
        content: 'Ocurrió un error al enviar la imagen. Por favor, inténtalo nuevamente.',
        accept: 'Aceptar'
      })
    }
    reader.onload = function(){
      // console.log(reader.result)
      const file = reader.result.split(';')
      fetch(
        BASE_URLS.Dinny.api + '/stores/logo?req_id=' + new Date().getTime(),
        {
          method: 'post',
          body: JSON.stringify({
            type: file[0].split("/")[1],
            content: file[1].replace(/base64,/, ''),
            id: body.id
          }),
          credentials: 'include'
        }
      )
      .then(function(response){
        if(response.ok){
          response.json().then(function(json){
            body.logo = json;
            saveStoreInfo(body);
          });
        }else{
          if(403 == response.status){
            window.location.href = 'login.html'
          }else{
            UI.hideLoader()
            UI.message({
              title: 'Datos generales y de contacto',
              content: 'Ocurrió un error al guardar la imagen. Por favor, inténtalo nuevamente.',
              accept: 'Aceptar'
            })
          }
        }
      })
    }
    reader.readAsDataURL(document.getElementById("store-logo").files[0])
  }else{
    saveStoreInfo(body)
  }

  function saveStoreInfo(body){
    fetch(
      BASE_URLS.Dinny.api + '/stores?req_id=' + new Date().getTime(),
      {
          credentials: 'include',
          method: 'put',
          body: JSON.stringify(body)
      }
    ).then(function(response){
      if(response.ok){
        if(location.hash && location.hash.toLowerCase() == "#formubication"){
          UI.hideLoader();
            UI.message({title: '', content: 'Se actualizaron los datos correctamente.', accept: 'Aceptar'});
        }
        else{
          let store_logo = document.querySelector('div.profile-form-logo img').src;
          if(body.hasOwnProperty('logo'))
            store_logo = body.logo;
          location.href = 'profile.html?store_name=' + encodeURIComponent(body.name) + '&store_image=' + encodeURIComponent(store_logo);
        }
      }else{
        if(403 == response.status){
          window.location.href = 'login.html'
        }else{
          return UI.message({title:'Datos generales y contacto', content: "Ocurrió un error al guardar la información.", accept: 'Aceptar'})
        }
      }
    })
    .catch(function(e){
      console.log(e);
      return UI.message({title:'Datos generales y contacto', content: "Ocurrió un error al actualizar el establecimiento.", accept: 'Aceptar'})
    })
  }
}
function validateEstablishmentFields(callback){
  let errors = []
  var valid = true
  if(document.querySelector('div.profile-form-logo img') == undefined){
    valid = false
    errors.push('Debe elegir una imagen para el logo.')
  }
  if(document.getElementById("store-name").value == '' || document.getElementById("store-name").value.length < 2){
    valid = false
    errors.push('Nombre no válido. Debe tener al menos dos caracteres.')
  }else{
    if(!/^[a-záéíóúüñÁÉÍÓÚÜÑ\d\-_\s#\'\.\-\(\)\&\/]+$/i.test(document.getElementById("store-name").value)){
      valid = false
      errors.push('Nombre no válido.')
    }
  }

  if(document.getElementById("store_prefix").value.length < 2 || document.getElementById("store_prefix").value.length > 5){
    valid = false
    errors.push('El prefijo debe tener entre 2 y 5 caracteres.')
  }else{
    if(!/^[0-9a-z]{2,5}$/ig.test(document.getElementById("store_prefix").value)){
      valid = false
      errors.push('Prefijo no válido.')
    }
  }

  if(document.getElementById("store_category").value == ""){
    valid = false
    errors.push('Seleccione un Tipo de Comida.')
  }

  if(document.getElementById("store-contact").value.length != 10){
    valid = false
    errors.push('Número de contacto no válido.')
  }else if(!/^[0-9]{10}$/.test(document.getElementById("store-contact").value)){
    errors.push('Número de contacto no válido.')
    valid = false
  }
  callback(valid, errors)
}
function validateFields(callback){
  let errors = []
  var valid = true
  if(document.getElementById("store-city").value == ''){
    valid = false
    errors.push('Ciudad no válida.')
  }else{
    if(!/^[a-záéíóúüÁÉÍÓÚÜ\d\-_\s#\.\-\(\)\&]{1,50}$/i.test(document.getElementById("store-city").value)){
      valid = false
      errors.push('Ciudad no válida, solo se permiten 50 caracteres.')
    }
  }
  if(document.getElementById("store-street").value == ''){
    valid = false
    errors.push('Calle no válida.')
  }else{
    if(!/^[a-záéíóúüÁÉÍÓÚÜ\d\-_\s#\.\-\(\)\&]{1,150}$/i.test(document.getElementById("store-street").value)){
      valid = false
      errors.push('Calle no válida, solo se permiten hasta 150 caracteres.')
    }
  }

  if(document.getElementById("store-neighborhood").value == ''){
    valid = false
    errors.push('Colonia no válida.')
  }else{
    if(!/^[a-záéíóúüÁÉÍÓÚÜ\d\-_\s#\.\-\(\)\&]{1,50}$/i.test(document.getElementById("store-neighborhood").value)){
      valid = false
      errors.push('Colonia no válida, solo se permiten hasta 50 caracteres.')
    }
  }
  if(document.getElementById("store-num").value == ''){
    valid = false
    errors.push('Número no válido.')
  }else if(!/^[0-9]{1,10}$/.test(document.getElementById("store-num").value)){
    valid = false
    errors.push('Número exterior no válido, solo se permiten hasta 10 dígitos.')
  }

  if(!/^[0-9a-z\-]{0,10}$/i.test(document.getElementById("store-int").value)){
    valid = false
    errors.push('Número interior no válido, solo se permiten hasta 10 caracteres.')
  }

  if(!/^[0-9]{5}$/.test(document.getElementById("store-zip_code").value) && document.getElementById("store-zip_code").value.length != 5){
    valid = false
    errors.push('Código postal no válido.')
  }
  callback(valid, errors)
}

document.getElementById('btnSaveStoreLocation').addEventListener('click', function(e){
  validateFields(function(valid, message){
    if(!valid){
      return UI.message({title:'Datos generales y contacto', content: message.join('<br />'), accept: 'Aceptar'})
    }else{
      saveAction(e)
    }
  })
})
document.getElementById('btnSaveStoreGeneral').addEventListener('click', function(e){
  validateEstablishmentFields(function(valid, message){
    if(!valid){
      return UI.message({title:'Datos generales y contacto', content: message.join('<br />'), accept: 'Aceptar'})
    }else{
      UI.message({title: '', content: 'Se actualizaron correctamente los datos.', accept: 'Aceptar'}, function(){
        saveAction(e);
    });
    }
  })
})

function previewPicture(e){

  let outPut = document.querySelector('.profile-form-logo');
  outPut.innerHTML = "";
  if(e.target.files.length > 0){
    let outPutImage = document.createElement("img");
    outPutImage.src = URL.createObjectURL(e.target.files[0]);
    outPutImage.onload = function() {
        URL.revokeObjectURL(outPutImage.src) // free memory

        if(this.width >= 500 && this.height >= 500){
          if(e.target.files[0].size < 4096000)
            outPut.appendChild(outPutImage);
          else{
            UI.message({title: 'Error', content: 'Por favor, seleccione una imagen de menos de 4MB.', accept: 'Aceptar'});
            e.target.value = "";
          }
        }
        else{
          UI.message({title: 'Error', content: 'Por favor, seleccione una imagen de al menos 500x500 pixeles.', accept: 'Aceptar'});
          e.target.value = "";
        }
    }
  }
}

function fun_AllowOnlyNumbers(e, element){
  if(e.which >= 48 && e.which <= 57)
    return true;

  return false;
}